import { render, staticRenderFns } from "./RenewMembershipMessage.vue?vue&type=template&id=3aef3a1a&"
import script from "./RenewMembershipMessage.vue?vue&type=script&lang=ts&"
export * from "./RenewMembershipMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports